import React from 'react';
import { Card, Stack } from 'react-bootstrap';
import { NavLink, useNavigate } from 'react-router-dom';
import './card.css';

const PopularCard = ({val}) => {
  const handleClick = () => {
    window.scrollTo(0, 0);  // Removed smooth behavior for instant jump to top
  };

  return (
    <Card className="package-card">
      <NavLink 
        to={`/tour-details/${val.id}`} 
        className="card-link"
        onClick={handleClick}
      >
        <div className="image-wrapper">
          <Card.Img
            variant="top"
            src={val.image}
            alt={val.title}
          />
          <div className="category-badges">
            {val.category.map((cat, index) => (
              <span key={index} className="category-badge">
                {cat}
              </span>
            ))}
          </div>
        </div>
        
        <Card.Body>
          <div className="location-info">
            <i className="bi bi-geo-alt-fill"></i>
            <span>{val.location}</span>
          </div>

          <h3 className="package-title">{val.title}</h3>
          
          <div className="package-footer">
            <div className="rating-wrapper">
              <i className="bi bi-star-fill"></i>
              <span className="rating">{val.rating}</span>
              <span className="reviews">({val.reviews} reviews)</span>
            </div>
            
            <div className="duration">
              <i className="bi bi-clock-fill"></i>
              <span>{val.days}</span>
            </div>
          </div>
        </Card.Body>
      </NavLink>
    </Card>
  );
}

export default PopularCard;
